import { EarningsInsightRecapResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CitationsSection } from '~/components/citations-section/CitationsSection';
import { DocumentsSection } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/document-section/DocumentsSection';

import * as S from './DocumentsAndCitations.styles';

export interface DocumentsAndCitationsProps {
  earningsRecapData: EarningsInsightRecapResponse;
  expandCitations: boolean;
}

export const DocumentsAndCitations = ({
  earningsRecapData,
  expandCitations,
}: DocumentsAndCitationsProps) => {
  const { t } = useTranslation(['earnings']);

  const hasDocuments = earningsRecapData.documents.length > 0;
  const hasCitations = earningsRecapData.citations.length > 0;

  if (!hasDocuments && !hasCitations) {
    return null;
  }

  return (
    <S.CitationsSectionWrapper>
      <S.CitationsTitle>
        {t('earningsInsight.drawer.citations')}
      </S.CitationsTitle>
      {hasDocuments && (
        <S.DocumentsWrapper>
          <DocumentsSection
            title={t('earningsInsight.drawer.documents')}
            count={earningsRecapData.documents.length}
            items={earningsRecapData.documents}
          />
        </S.DocumentsWrapper>
      )}
      {hasCitations && (
        <CitationsSection
          title={t('earningsInsight.drawer.webLinks')}
          count={earningsRecapData.citations.length}
          items={earningsRecapData.citations}
          isExpanded={expandCitations}
        />
      )}
    </S.CitationsSectionWrapper>
  );
};
